import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    ODOO: "Odoo",
    FRONTEND: "Frontend",
    BACKEND: "Backend",
  };

  const projectsData = [
    {
      title: "Accounting System",
      projectInfo:
        "Frontend Developer Building custom design Vue 3 components with different designs and functionality to solve complex logic pages with unique designs for each element.",
      client: "Comiteo",
      technologies: "VUE, Tailwind, Element UI, PHP, Symfony",
      industry: "Accounting",
      date: "July 16, 2021",
      url: {
        name: "www.comiteo.net",
        link: "https://www.comiteo.net",
      },
      socialLinks: {
        website: "https://www.comiteo.net",
        mail: "mailto:leykimteng@gmail.com",
        facebook: "https://www.facebook.com",
      },
      thumbImage: "images/projects/comiteo-1.jpeg",
      sliderImages: [
        "images/projects/comiteo-1.jpeg",
      ],
      categories: [filters.FRONTEND],
    },
    {
      title: "CMS System for blogging",
      projectInfo:
        "Implement CMS system for blogging free software and advertise",
      client: "Ruby Clinton",
      technologies: "Strapi, Postgresql, Gatsby, React, Lerna",
      industry: "Website",
      date: "January 16, 2023",
      url: {
        name: "www.sys-kh.com",
        link: "https://sys-kh.com/",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/",
        website: "https://sys-kh.com/",
        mail: "mailto:leykimteng@gmail.com",
      },
      thumbImage: "images/projects/strapi-1.jpeg",
      sliderImages: [
        "images/projects/strapi-2.png",
      ],
      categories: [filters.BACKEND],
    },
    {
      title: "Odoo Payway Payment Acquirer",
      projectInfo:
        "Developed Payment module for Odoo Ecommerce that using ABA Payway API V1",
      client: "ERP Cambodia",
      technologies: "Odoo, HTML5, CSS3, Python, Javascript, Rest API",
      industry: "ERP",
      date: "October 16, 2021",
      url: {
        name: "Odoo Payment Payway App",
        link: "https://apps.odoo.com/apps/modules/14.0/payment_payway/",
      },
      socialLinks: {
        website: "https://www.erpcambodia.biz/",
        facebook: "https://www.facebook.com",
        mail: "mailto:leykimteng@gmail.com",
      },
      thumbImage: "images/projects/odoo-payment-1.png",
      sliderImages: [
        "images/projects/odoo-payment-2.png",
        "images/projects/odoo-payment-3.png",
      ],
      categories: [filters.ODOO],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
